var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCampingplatz = function SvgCampingplatz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Campingplatz")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campingplatz",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-camping-tent@24x24",
    transform: "translate(34.000000, 34.500000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "41 56.5 26 81.5 56 81.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "50.3939111 0.5 0 81.5 83 81.5 32.6060889 0.5"
  })))));
};
export default SvgCampingplatz;